<template>
<div class="chapter">
<div class="inner_page">
<div>
<div class="chapter" id="ack">
<div class="figure">
<p class="fig"><img alt="" height="30" src="images/eer-kaiulani-ornament.jpg" width="61"/></p>
</div>
<p class="ctfm"><a href="#/eerkaiulani0008#rack">Acknowledgments</a></p>
<p class="pf">It seems fitting to open with a word of gratitude. First, I thank two knowledgeable and gracious historians, R. Kawika Makanani of the Kamehameha School and Holly McEldowney of Hawaii’s State Historic Preservation Division, for their eye-opening discussions of the continually evolving interpretations of Hawaii’s past. I owe a great debt to each for their input, especially on the presentation of the islands’ history in <a href="#/eerkaiulani0014#ch01">Chapter One</a>.</p>
<p>On a more personal note, thanks to Lorrie Lazar, without whom no words would appear on these pages, and to Jenny Lazar, who gave the manuscript an early read through a teenager’s eyes.</p>
<p>Thanks to Mary Ann O’Roark for suggestions and support every step of the way, and to my wonderful husband, Robert Scott, my anchor in every storm.</p>
<p>Thanks, too, to all those who recognized the importance of Ka‘iulani’s story: Susan Cohen, a sane voice in a crazy profession, who has somehow become the official agent of Princess Ka‘iulani; to Amy DeVries for commissioning this book, Mary Hietbrink for strengthening it, Judy Zylstra for standing behind it, and Gayle Brown and Klaas Wolterstorff for the special design.</p>
<p>Mahalo Nui!</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eer-kaiulani-0009.vue?cf676594